export class AwsRestoreAccountConnectivityConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcConfigs",
            "baseName": "vpcConfigs",
            "type": "Array<AwsVpcConnectivityConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRestoreAccountConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
